import { useCountUp } from "@/hooks/useCountUp";

const BARS = [32, 48, 40, 60, 55, 75, 68, 92];

function formatTR(num, decimals = 0) {
  return num.toLocaleString("tr-TR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export default function PhoneMockup({ animate }) {
  const purchases = useCountUp(1245, animate, 1600);
  const spend = useCountUp(152735, animate, 1800);
  const roas = useCountUp(4.62, animate, 1600);

  return (
    <div
      className="relative mx-auto w-[280px] sm:w-[300px] transition-transform duration-700"
      style={{
        transform: animate ? "perspective(1000px) rotateY(0deg)" : "perspective(1000px) rotateY(-10deg)",
      }}
      data-testid="hero-phone-mockup"
    >
      <div className="relative rounded-[2.5rem] border border-white/10 bg-[#0A0E17] p-3 shadow-[0_30px_80px_rgba(0,0,0,0.6)]">
        {/* Notch */}
        <div className="absolute left-1/2 top-3 h-1.5 w-16 -translate-x-1/2 rounded-full bg-black/60" />

        <div className="rounded-[2rem] bg-gradient-to-b from-[#0F141E] to-[#050608] px-4 pb-6 pt-8 min-h-[420px]">
          {/* Header */}
          <div className="mb-5 flex items-center justify-between">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
              Reklam Performansı
            </span>
            <span className="flex items-center gap-1.5 text-[10px] font-semibold text-emerald-400">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
              </span>
              Canlı
            </span>
          </div>

          {/* Stats */}
          <div className="space-y-3">
            <div className="flex items-center justify-between rounded-xl border border-white/5 bg-white/[0.02] px-3 py-2.5">
              <div>
                <p className="text-[10px] uppercase tracking-wide text-slate-500">Satın Alma</p>
                <p className="text-lg font-bold text-white">{formatTR(purchases)}</p>
              </div>
              <span className="text-xs font-semibold text-emerald-400">↑ %58,7</span>
            </div>
            <div className="flex items-center justify-between rounded-xl border border-white/5 bg-white/[0.02] px-3 py-2.5">
              <div>
                <p className="text-[10px] uppercase tracking-wide text-slate-500">Harcanan</p>
                <p className="text-lg font-bold text-white">₺{formatTR(spend)}</p>
              </div>
            </div>
            <div className="flex items-center justify-between rounded-xl border border-gold/20 bg-gold/[0.06] px-3 py-2.5">
              <div>
                <p className="text-[10px] uppercase tracking-wide text-slate-500">ROAS</p>
                <p className="text-lg font-bold text-gold-light">{formatTR(roas, 2)}</p>
              </div>
              <span className="text-xs font-semibold text-emerald-400">↑ %72,1</span>
            </div>
          </div>

          {/* Bar chart */}
          <div className="mt-5 flex h-24 items-end gap-1.5 rounded-xl border border-white/5 bg-white/[0.02] p-3">
            {BARS.map((h, i) => (
              <div
                key={i}
                className="flex-1 rounded-t-sm origin-bottom transition-transform duration-700 ease-out"
                style={{
                  height: `${h}%`,
                  background: i % 3 === 0 ? "linear-gradient(180deg,#FFDF73,#D4AF37)" : "linear-gradient(180deg,#3B82F6,#1E3A8A)",
                  transform: animate ? "scaleY(1)" : "scaleY(0)",
                  transitionDelay: `${i * 80}ms`,
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
